<template>
    <div class="vip-manager">
        <div class="add-box" style="text-align: left;margin-bottom:20px;"><a-button type="primary" @click="addShow=true">添加</a-button></div>
        <a-table
                :dataSource="list"
                rowKey="id"
                :loading="loading"
                :pagination="false">
            <a-table-column
                    title="會員類型"
                    align="center"
                    dataIndex="vipDesc"></a-table-column>
            <a-table-column
                    title="類型ID"
                    align="center"
                    dataIndex="id"></a-table-column>
            <a-table-column
                    align="center"
                    title="創建時間">
                <template slot-scope="item,row,index">
                    {{row.createTime | trans-date}}
                </template>
            </a-table-column>
            <a-table-column
                    align="center"
                    title="操作">
                <template slot-scope="row,item,index">
                    <a-space>
                        <a-button size="small" @click="edit(item)">編輯</a-button>
                        <a-button size="small" @click="del(item)">刪除</a-button>
                    </a-space>
                </template>
            </a-table-column>
        </a-table>
        <a-modal
                :title="editer ? '編輯' : '添加'"
                :visible="addShow"
                :confirm-loading="confirmLoading"
                @ok="sub"
                @cancel="cancel"
        >
            <div class="in-box">
                <div class="item"><span>會員名稱：</span><a-input style="width:200px;" placeholder="輸入會員名稱" v-model="vipDesc"></a-input></div>
            </div>
        </a-modal>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                editObj:null,
                editer:false,
                addShow:false,
                loading:false,
                confirmLoading:false,
                vipDesc:undefined,
                vipType:undefined,
                list:[]
            }
        },
        methods: {
            edit(item){
                this.editObj=item;
                this.editer=true;
                this.vipType=item.vipType;
                this.vipDesc=item.vipDesc;
                this.addShow=true;
            },
            valiDate(){
                if(this.vipDesc === '' || !this.vipDesc){
                    this.$Message.warning('請輸入會員名稱');
                    return false;
                }
                return true;
            },
            sub(){
                let self=this;
                if(!this.valiDate()){return false;}
                let url,data;
                data={
                    vipDesc:this.vipDesc
                }
                if(this.editer){
                    url='/manager/vip/update'
                    data.id=this.editObj.id;
                }else{
                    url='/manager/vip/add'
                    delete data.id;
                }
                this.confirmLoading=true;
                self.$http({
                    method: 'post',
                    url: url,
                    data:data
                }).then(function(res){
                    self.$Message.success('操作成功')
                    self.getList()
                    self.cancel()
                    self.confirmLoading=false;
                }).catch(err=>{
                    self.confirmLoading=false;
                })
            },
            cancel(){
                this.editObj=null;
                this.editer=false;
                this.addShow=false;
                this.vipType=undefined;
                this.vipDesc=undefined;
            },
            del(item){
                let self=this;
                this.$Confirm({
                    title:'確定刪除嗎？',
                    onOk(){
                        self.$http({
                            method: 'post',
                            url: '/manager/vip/delete',
                            data:{
                                id:item.id
                            }
                        }).then(function(res){
                            self.$Message.success('操作成功')
                            self.getList()
                        }).catch(err=>{
                        })
                    },
                    onCancel(){
                    }
                })
            },
            getList(){
                let self=this;
                this.loading=true;
                self.$http({
                    method: 'post',
                    url: '/manager/vip/list',
                }).then(function(res){
                    self.loading=false;
                    self.list=res.data;
                }).catch(err=>{
                    self.loading=false;
                    self.$Message.error(JSON.stringify(err))
                })
            }
        },
        created() {
            this.$emit('breadcrumbChange',['會員管理','會員類型'])
            this.getList();
        },
    }
</script>
<style lang="less">
    .vip-manager{

    }
</style>